import React from "react";
import InfoBox from "~/components/infoBoxes/InfoBox.jsx";
import { TurnrCardHeader } from "~/components/card/TurnrCard.jsx";
import EntityActionsDotsMenu from "~/components/entityAction/EntityActionsDotsMenu.jsx";
import CollapsibleTurnrCard from "~/components/card/CollapsibleTurnrCard.jsx";

function HeaderPart({ headerChip, chevronElement, appProps, headerTitle, onUpdate, dateChip, statusChips, optionsEntity, headerIcon, headerTooltip, headerHref }) {
    return (
        <TurnrCardHeader style={{ width: "100%" }}>
            <div
                style={{
                    width: "100%",
                    display: "flex",
                    gridGap: "10px",
                    justifyContent: "space-between",
                }}
            >
                <div
                    style={{
                        display: "flex",
                        flexWrap: "wrap",
                        justifyContent: "space-between",
                        alignItems: "center",
                        gridGap: "10px",
                        width: "100%",
                    }}
                >
                    <div
                        style={{
                            display: "flex",
                            flexDirection: "row",
                            justifyContent: "space-between",
                            alignItems: "center",
                        }}
                    >
                        <div
                            style={{
                                display: "flex",
                                alignItems: "center",
                                gridGap: "10px",
                            }}
                        >
                            <InfoBox
                                vertical={true}
                                items={[
                                    {
                                        icon: headerIcon,
                                        label: headerTooltip,
                                        value: (
                                            <div
                                                style={{
                                                    whiteSpace: "nowrap",
                                                }}
                                            >
                                                {headerTitle}
                                            </div>
                                        ),
                                        href: headerHref,
                                    },
                                ]}
                            />

                            {headerChip}
                            {chevronElement}
                        </div>
                    </div>
                    <div
                        style={{
                            display: "flex",
                            flexWrap: "wrap",
                            gridGap: "10px",
                            alignItems: "center",
                            // marginLeft: "auto",
                        }}
                    >
                        {dateChip && <div className={"subtitle muted"}>{dateChip}</div>}
                        {statusChips?.map((statusChip) => {
                            return statusChip;
                        })}
                    </div>
                </div>
                {optionsEntity && <EntityActionsDotsMenu appProps={appProps} entity={optionsEntity} onSuccess={onUpdate} />}
            </div>
        </TurnrCardHeader>
    );
}

export default function CollapsibleReturnPart(props) {
    let { children } = props;

    return (
        <CollapsibleTurnrCard HeaderPart={HeaderPart} headerPartProps={props}>
            {children}
        </CollapsibleTurnrCard>
    );
}
